import {
    Component,
    OnInit,
    HostBinding,
    OnDestroy,
    Input
} from '@angular/core';

import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { switchMap, takeUntil, map, tap } from 'rxjs/operators';

import { SeasonsUsersRanksService } from '../seasons-users-ranks.service';

@Component({
    templateUrl: './profile-seasonal-world.component.pug',
    styleUrls: ['./profile-seasonal-world.component.less'],
    providers: []
})
export class ProfileSeasonalWorldComponent implements OnInit, OnDestroy {
    _destroySbj: Subject<void> = new Subject();

    _userSbj: BehaviorSubject<any> = new BehaviorSubject(null);
    public user$: Observable<any> = this._userSbj.asObservable();
    @Input() set user(user: string) {
        this._userSbj.next(JSON.parse(user));
    };

    @HostBinding('class.--ui') _ui = true;
    @HostBinding('attr.hidden') get _hidden() {
        return !this._rewardsSbj.getValue().length ? true : null;
    }

    _rewardsSbj: BehaviorSubject<any[]> = new BehaviorSubject([]);
    public rewards$: Observable<any[]> = this._rewardsSbj.asObservable();

    constructor(
        private _seasonsUsersRanksSrv: SeasonsUsersRanksService
    ) {
    }

    async ngOnInit() {
        this.user$
            .pipe(takeUntil(this._destroySbj))
            .pipe(switchMap((user) => this._seasonsUsersRanksSrv.getRewards(user._id)))
            .pipe(map(({ list }) => list.filter(i => i.rank <= 100)))
            .pipe(tap((list) => this._rewardsSbj.next(list)))
            .subscribe();
    }

    ngOnDestroy() {
        this._dispose();
    }

    _dispose() {
        this._destroySbj.next();
        this._destroySbj.complete();
    }
}
